import React, { useState } from "react";
import Button  from "../Button";

const CopyButton = ({ textToCopy, icon = "copy", copiedIcon = "tick", buttonText = "Copy" }) => {
  const [hasCopied, setHasCopied] = useState(false);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }

    setHasCopied(true);
    setTimeout(() => setHasCopied(false), 2000);
  };

  return (
    <Button
      icon={hasCopied ? copiedIcon : icon}
      text={hasCopied ? "Copied" : buttonText}
      onClick={() => copyToClipboard(textToCopy)}
    />
  );
};

export default CopyButton;